module.exports = __webpack_public_path__ + "static/15-Flowers variable sizes-9b6dad5d93bed871efeb77d15f9b8650.jpg";